(ns hai.tasks.header
  "The tinted header row every tasks surface shares: task icon + title (a
   link when `:href` is given) with action buttons on the right. Actions
   come as children — hosts wrap their own `:button.bar-action-btn`s in
   tooltips as needed. Mirrors [[hai.notes.header]]."
  (:require
   [hai.ui.icons :as icons]
   [hai.ui.tokens :as t]
   [lambdaisland.ornament :as o]))

;; One height for every card header, with or without the ＋ pill: the minimum
;; governs and the row centres whatever it holds, so no vertical padding.
(o/defstyled bar :div
  {:display "flex" :align-items "center" :gap "10px"
   :padding "0 18px"
   :min-height "56px"
   :box-sizing "border-box"
   :background t/--tasks
   :color t/--note-kraft}
  [:.bar-icon
   {:display "inline-flex" :align-items "center"
    :color t/--note-kraft}
   ;; Material fill icon (unlike the stroke icons elsewhere) — keep the page's
   ;; `svg {fill: currentColor}` and pin its size.
   [:svg {:fill "currentColor" :width "20px" :height "20px"}]]
  [:.bar-title
   {:font-size "16px" :font-weight "700" :line-height "1.2"
    :margin "0"
    :letter-spacing "-0.005em"
    :color t/--note-kraft}]
  [:.bar-title-link
   {:display "inline-flex" :align-items "center" :gap "10px"
    :color "inherit"
    :text-decoration "none"
    :cursor "pointer"}
   [:&:hover
    [:.bar-title {:text-decoration "underline" :text-underline-offset "3px"}]]]
  [:.bar-actions
   {:margin-left "auto"
    :display "flex" :align-items "center" :gap "6px"}]
  [:.bar-action-btn
   {:width "28px" :height "28px"
    :border "none" :border-radius "999px"
    :background "transparent"
    :padding "0"
    :color t/--note-kraft
    :cursor "pointer"
    :display "inline-flex" :align-items "center" :justify-content "center"
    :transition "background 0.15s ease"}
   [:&:hover {:background t/--note-kraft-10}]
   [:svg {:fill "currentColor"}]]
  ([{:keys [title href target rel]} & actions]
   ;; Keep the root fragment's first child a concrete element (never a bare
   ;; `[:<>]`): Ornament's fragment-flattening recurses into a leading `:<>`
   ;; child and drops its siblings, which would silently swallow the whole
   ;; `.bar-actions` group.
   (into
    [:<>]
    (concat
     (if href
       [[:a.bar-title-link {:href href :target target :rel rel}
         [:span.bar-icon [icons/humble-task]]
         [:h2.bar-title title]]]
       [[:span.bar-icon [icons/humble-task]]
        [:h2.bar-title title]])
     [(into [:div.bar-actions] actions)]))))
